export const DICTIONARY_TYPES_NAME = {
  1: "Tekst",
  2: "Numer",
};

export const DICTIONARY_TYPES = [
  { label: "Tekst", value: 1 },
  { label: "Numer", value: 2 },
];
